// Project data - simplified for homepage and projects page
export const projectsData = [
  {
    id: 1,
    slug: "sakli-bahce-konya",
    seoTitle: "Saklı Bahçe Konya Villa Projesi | Konyap Mühendislik",
    seoDescription:
      "Meram'da butik villa konseptiyle lüks konut projeleri. Saklı Bahçe Butik Villaları Konya'nın en prestijli yaşam alanlarından biri.",
    title: "Saklı Bahçe Butik Villaları",
    status: "completed",
    statusLabel: "Tamamlandı",
    location: "Meram",
    year: "2026",
    units: "3+1 / 4+1 Villa Seçenekleri",
    area: "2.000 m²",
    type: "Villa",
    address: "Hocacihan Hacılar, Katar Sk. 42080",
    coordinates: [37.88800095484222, 32.43447459549108],
    shortDescription:
      "Meramda butik villa konseptiyle lüks ve konforu bir araya getiren özel yaşam alanları.",
    description:
      "Modern butik viila konseptiyle tasarlanan Saklı Bahçe Butik Villaları, Meram'ın en prestijli lokasyonunda lüks ve konforu bir araya getiren özel yaşam alanları sunuyor. Geniş yaşam alanları, şık detayları ve doğal çevresiyle huzurlu bir yaşamın kapılarını aralıyor.",
    coverImage: "/images/5-projeler/sakli_bahce/01_kapak.png",
    /*coverVideo:
      "https://www.youtube.com/embed/RRWpY4Rddz0?autoplay=1&mute=1&loop=1&controls=0&rel=0&modestbranding=1&playlist=RRWpY4Rddz0",*/
    gallery: [
      {
        type: "youtube",
        src: "https://www.youtube.com/embed/AJq7viox6To",
        poster: "images/5-projeler/sakli_bahce/01_kapak.png",
        thumb: "images/5-projeler/sakli_bahce/01_kapak.png",
      },
      "/images/5-projeler/sakli_bahce/01_kapak.png",
      "/images/5-projeler/sakli_bahce/1_s.png",
      "/images/5-projeler/sakli_bahce/1_sd.png",
      "/images/5-projeler/sakli_bahce/2_s.png",
      "/images/5-projeler/sakli_bahce/3_s.png",
      "/images/5-projeler/sakli_bahce/4_s.png",
      "/images/5-projeler/sakli_bahce/5_s.png",
      "/images/5-projeler/sakli_bahce/6_s.png",
      "/images/5-projeler/sakli_bahce/7_s.png",
      "/images/5-projeler/sakli_bahce/8_s.png",
      "/images/5-projeler/sakli_bahce/9_s.png",
      "/images/5-projeler/sakli_bahce/10_s.png",
      "/images/5-projeler/sakli_bahce/11_s.png",
      "/images/5-projeler/sakli_bahce/12_s.png",
      "/images/5-projeler/sakli_bahce/12_sd.png",
      "/images/5-projeler/sakli_bahce/22_s.png",
      "/images/5-projeler/sakli_bahce/13_s.png",
      "/images/5-projeler/sakli_bahce/14_s.png",
      "/images/5-projeler/sakli_bahce/15_s.png",
      "/images/5-projeler/sakli_bahce/16_s.png",
      "/images/5-projeler/sakli_bahce/17_s.png",
      "/images/5-projeler/sakli_bahce/18_s.png",
      "/images/5-projeler/sakli_bahce/21_s.png",
      "/images/5-projeler/sakli_bahce/19_s.png",
      "/images/5-projeler/sakli_bahce/19_sd.png",
      "/images/5-projeler/sakli_bahce/20_sd.png",
    ],

    features: [
      "Panjur Alt Yapısı",
      "Özel Bahçe Alanı",
      "Özel Teras Alanı",
      "Özel Barbekü İmkanı",
      "Bireysel Isıtma",
      "7/24 Site Güvenliği",
      "Çocuk oyun alanı",
      "Açık Otopark Alanı",
      "Panoramik manzara",
      "Kapalı Devre Kamera Sistemi",
      "Yerden Isıtma",
      "Çevreye duyarlı mimari",
    ],
    technicalDetails: {
      constructionArea: "3.000 m²",
      greenArea: "4.000 m²",
      blocks: "8 Villa",
      floors: "2 Kat",
      delivery: "Teslim Edildi - Mayıs 2026",
    },
    nearby: [
      "Meram Tıp Hastahanesi - 1.3 km",
      "Akyokuş Kasrı - 3 km",
      "Konya Şehir Merkezi - 5 km",
    ],
    materialHighlights: [
      {
        title: "Bosch Ev Aletleri",
        description:
          "Yüksek performanslı, enerji verimli ve uzun ömürlü Bosch marka ankastre beyaz eşyalar.",
      },
      {
        title: "Artema & Creavit Vitrifiye",
        description:
          "Modern tasarıma sahip, kaliteli ve uzun ömürlü Artema ve Creavit marka banyo ürünleri.",
      },
      {
        title: "Egepen Pencere Sistemleri",
        description:
          "Isı ve ses yalıtımı sağlayan, dayanıklı ve estetik Egepen PVC pencere sistemleri.",
      },
      {
        title: "Bordo Çelik Kapı",
        description:
          "Üst düzey güvenlik sunan, sağlam ve şık tasarımlı Bordo marka çelik giriş kapısı.",
      },
      {
        title: "AGT Parke & Dekorasyon",
        description:
          "Estetik görünüm ve dayanıklılığı bir araya getiren AGT marka parke ve dekoratif çözümler.",
      },
      {
        title: "Kütahya Seramik",
        description:
          "Kaliteli, şık ve uzun ömürlü Kütahya Seramik kaplama ürünleri.",
      },
      {
        title: "Würth Seramik Yapıştırıcı",
        description:
          "Güçlü tutuş sağlayan, dayanıklı ve profesyonel Würth seramik yapıştırıcı çözümleri.",
      },
      {
        title: "Filli Boya Dış Cephe",
        description:
          "Dalmaçyalı dış cephe kaplaması ile yüksek yalıtım ve uzun ömürlü dış cephe koruması.",
      },
      {
        title: "Filli Boya İç Cephe",
        description:
          "Agusto serisi ile estetik, silinebilir ve uzun ömürlü iç cephe boya çözümleri.",
      },
      {
        title: "Çelik Merdiven",
        description:
          "Modern mimariye uygun, dayanıklı ve uzun ömürlü çelik merdiven tasarımı.",
      },
      {
        title: "Lake Kapılar",
        description:
          "Şık, modern ve kaliteli yüzeye sahip lake iç kapı çözümleri.",
      },
      {
        title: "Çimstone Mutfak Tezgahı",
        description:
          "Dayanıklı, hijyenik ve estetik Çimstone mutfak tezgahı uygulamaları.",
      },
    ],
    floorPlans: [
      {
        typeTitle: "3+1 (4) Villa Tipi",
        plans: [
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani3_1.png",
            label: "Zemin Kat\n• 4 Salon +  Hol 30m²\n• 9 Bahce 23.4m²",
          },
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani3_2.png",
            label:
              "1. Kat\n• 5 Çocuk Yatak Odası 1 10.55m²\n• 6 Banyo 4.4m²\n• 7 Çocuk Yatak Odası 2 10.55m²",
          },
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani3_3.png",
            label:
              "2. Kat\n• 1 Ebeveyn Yatak Odası 17m²\n• 2 Ebeveyn Banyosu 3.5m²\n• 3 Giyinme Odası 6.6m²",
          },
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani4.png",
            label: "Teras\n• 1 Teras 11m²",
          },
        ],
      },
      {
        typeTitle: "4+1 (4) Villa Tipi",
        plans: [
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani1.png",
            label: "Zemin Kat\n• 5 Salon +  Hol 30m²\n• 10 Bahçe 23.4m²",
          },
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani2.png",
            label:
              "1. Kat\n• 6 Ebeveyn Yatak Odası 17.2m²\n• 7 Banyo 4.5m²\n• 8 Çocuk Yatak Odası 11m²",
          },
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani3.png",
            label:
              "2. Kat\n• 1 Çocuk Yatak Odası 1 10.32m²\n• 2 Çocuk Yatak Odası 2 10m²\n• 3 Banyo 4.1m²",
          },
          {
            image: "/images/5-projeler/sakli_bahce/kat_plani4.png",
            label: "Teras\n• 1 Teras 11m²",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    slug: "meram-kent-konut-yapi-kooperatifi",
    seoTitle: "Meram Kent Konut Yapı Kooperatifi Konya | Konyap Mühendislik",
    seoDescription:
      "Meram'da 70 daire ve 10 ticari alan içeren modern kooperatif projesi. Konyap Mühendislik Konya inşaat projeleri.",
    title: "Meram Kent Konut Yapı Kooperatifi",
    status: "planning",
    statusLabel: "Planlama",
    location: "Meram",
    year: "2026",
    units: "70 daire + 10 Ticari",
    area: "5.200 m²",
    type: "Kooperatif",
    address: "Uzunharmanlar, 42010 Meram/Konya",
    coordinates: [37.84854353182793, 32.49426299979534],
    shortDescription:
      "Meram'da 70 daire ve 10 ticari alan içeren modern konut projesi.",
    description:
      "Yatırım fırsatı sunan Meram Kent Konut Yapı Kooperatifi projesi, Meram'ın gelişen bölgesinde 70 daire ve 10 ticari alan içeren modern bir konut projesidir. Geniş yaşam alanları, şık detayları ve çevre dostu tasarımıyla konforlu bir yaşam sunmayı hedefliyor.",
    coverImage: "/images/5-projeler/S/s.s.png",
    gallery: [
      {
        type: "youtube",
        src: "https://www.youtube.com/embed/e5LzwQlC5Ts",
        poster: "images/5-projeler/S/s.s.png",
        thumb: "images/5-projeler/S/s.s.png",
      },
      "/images/5-projeler/S/s.s.png",
      "/images/5-projeler/S/s1.png",
      "/images/5-projeler/S/s2.png",
      "/images/5-projeler/S/s3.png",
      "/images/5-projeler/S/s4.png",
    ],
    features: [
      "Geniş Yeşil Alanlar",
      "Çocuk Oyun Alanları",
      "Modern Mutfak",
      "Depolama Alanları",
      "Güvenlik Sistemi",
      "Merkezi Isıtma",
      "Panoramik Manzara",
      "Açık Otopark",
      "Kapalı Otopark",
      "Güvenlik Sistemi",
      "Çevreci Mimarlık",
    ],
    materialHighlights: [
      // Buraya bu projeye ait marka & malzeme özelliklerini ekle
      // Örnek:
      // { title: "Vitra", description: "Banyo ve ıslak hacimlerde premium seramik ve armatür." },
    ],
    technicalDetails: {
      constructionArea: "15.000 m²",
      greenArea: "1.000 m²",
      blocks: "5 Blok",
      shopCount: "10 Ticari Alan",
      floors: "8 Kat",
      delivery: "Yapım Aşamasında - 2030",
    },
    nearby: [],
  },
  {
    id: 3,
    slug: "villa-selver-konya",
    seoTitle: "Villa Selver Konya Meram | Konyap Mühendislik",
    seoDescription:
      "Meram'da modern mimarisiyle özel 4+1 villa projesi. Villa Selver Konya'nın en ayrıcalıklı konut projelerinden biri.",
    title: "Villa Selver",
    status: "completed",
    statusLabel: "Tamamlandı",
    location: "Meram",
    year: "2025",
    units: "1 Adet 4+1 Villa",
    area: "1.000 m²",
    type: "Villa",
    address: "Ateşbaz-I Veli, Müdafa Sk. Meram/Konya",
    coordinates: [37.855193425532576, 32.45339469905418],
    shortDescription:
      "Meram'da modern mimarisi ve ferah tasarımıyla ayrıcalıklı 4+1 villa.",
    description:
      "Konya’nın en prestijli lokasyonunda yer alan bu özel 4+1 villa, modern mimarisi ve ferah tasarımıyla ayrıcalıklı bir yaşam sunuyor. Geniş yaşam alanları, şık detayları ve doğal çevresiyle huzurlu bir yaşamın kapılarını aralıyor.",
    coverImage: "/images/5-projeler/villa_selver/kapak.png",
    gallery: [
      {
        type: "youtube",
        src: "https://www.youtube.com/embed/Wlim1alwc7E",
        poster: "images/5-projeler/villa_selver/kapak.png",
        thumb: "images/5-projeler/villa_selver/kapak.png",
      },
      "/images/5-projeler/villa_selver/kapak.png",
    ],
    features: [
      "Geniş Teras",
      "Merkezi Isıtma",
      "Panoramik Manzara",
      "Yeşil Alan",
      "Açık Otopark",
      "Güvenlik Sistemi",
    ],
    materialHighlights: [
      // Buraya bu projeye ait marka & malzeme özelliklerini ekle
    ],
    technicalDetails: {
      constructionArea: "1.000 m²",
      greenArea: "200 m²",
      blocks: "",
      floors: "1 Kat",
      delivery: "Teslim Edildi - Mayıs 2026",
    },
    nearby: [
      "Meram Devlet Hastanesi - 1.5 km",
      "Necmettin Erbakan Üniversitesi - 1.7 km",
      "Meram Kafeler Sokağı - 2.3 km",
    ],
  },
  {
    id: 4,
    slug: "villa-konyap-meram",
    seoTitle: "Villa Konyap Meram Konya | Konyap Mühendislik",
    seoDescription:
      "Meram'da lüks 7+1 özel villa projesi. Villa Konyap modern mimarisi ve geniş yaşam alanlarıyla Konya'nın prestijli villa projeleri arasında.",
    title: "Villa Konyap",
    status: "completed",
    statusLabel: "Tamamlandı",
    location: "Meram",
    year: "2026",
    units: "1 Adet 7+1 Villa",
    area: "1.000 m²",
    type: "Villa",
    address: "Yaylapınar, Kaş Cd. 75 A, 42010 Meram/Konya",
    coordinates: [37.81136695180958, 32.50006232698638],
    shortDescription:
      "Lüks ve konforun buluştuğu, modern yaşama uygun 7+1 özel villa projesi.",
    description:
      "Konyap Mühendislik olarak hayata geçirdiğimiz 7+1 Villa Projesi, lüks ve konforun estetik bir tasarımla buluştuğu, modern yaşamın tüm ihtiyaçlarını karşılayan bir yaşam alanıdır. Geniş ve ferah iç mekan tasarımıyla dikkat çeken bu proje, hem aile yaşamı hem de misafir ağırlama için ideal bir çözüm sunar.",
    coverImage: "/images/5-projeler/Villakonyap/kapak.png",
    gallery: ["/images/5-projeler/Villakonyap/kapak.png"],
    features: [
      "Geniş Teras",
      "Akıllı Ev Sistemleri",
      "Geniş Salon",
      "Modern Mutfak",
      "Depolama Alanları",
      "Güvenlik Sistemi",
      "Merkezi Isıtma",
      "Panoramik Manzara",
      "Yeşil Alan",
      "Açık Otopark",
      "Güvenlik Sistemi",
      "Çevreci Mimarlık",
    ],
    materialHighlights: [
      // Buraya bu projeye ait marka & malzeme özelliklerini ekle
    ],
    technicalDetails: {
      constructionArea: "1.000 m²",
      greenArea: "300 m²",
      blocks: "",
      floors: "2 Kat",
      delivery: "Teslim Edildi",
    },
    nearby: [],
  },
  {
    id: 5,
    slug: "konyap-apartmani-karatay",
    seoTitle: "Konyap Apartmanı Karatay Konya | Konyap Mühendislik",
    seoDescription:
      "Karatay'da 9 konumluk modern apartman projesi. Konyap Apartmanı Konya'da 4+1, 3+1 ve 2+1 seçenekleriyle kaliteli şehir yaşamı.",
    title: "Konyap Apartmanı",
    status: "completed",
    statusLabel: "Tamamlandı",
    location: "Karatay",
    year: "2024",
    units: "9 Konut",
    area: "3.500 m²",
    type: "Apartman",
    address: "Türkmenoğlu Çk. No:15, 42060 Karatay/Konya",
    coordinates: [37.87635969011339, 32.50804667096767],
    shortDescription:
      "Karatay'da 4+1, 3+1 ve 2+1 seçenekleriyle konforlu şehir yaşamı.",
    description:
      "Farklı aile tipleri ve yaşam tarzlarına hitap eden 4+1, 3+1 ve 2+1 daire seçenekleriyle konforlu ve işlevsel bir yaşam alanı oluşturmak üzere tasarlanmıştır.",

    coverImage: "/images/5-projeler/konyap_apartmani/1_out.png",
    gallery: [
      {
        type: "youtube",
        src: "https://www.youtube.com/embed/susk2xM7geA",
        poster: "images/5-projeler/sakli_bahce/01_kapak.png",
        thumb: "images/5-projeler/sakli_bahce/01_kapak.png",
      },
      {
        type: "youtube",
        src: "https://www.youtube.com/embed/M9W-tz06QoA",
        poster: "images/5-projeler/sakli_bahce/01_kapak.png",
        thumb: "images/5-projeler/sakli_bahce/01_kapak.png",
      },

      "/images/5-projeler/konyap_apartmani/1_out.png",
      "/images/5-projeler/konyap_apartmani/2_out.png",
      "/images/5-projeler/konyap_apartmani/3_hol.png",
      "/images/5-projeler/konyap_apartmani/3.1_hol2.png",
      "/images/5-projeler/konyap_apartmani/4_livingroom.png",
      "/images/5-projeler/konyap_apartmani/4.1_livingroom.png",
      "/images/5-projeler/konyap_apartmani/5_salon.png",
      "/images/5-projeler/konyap_apartmani/6_kitchen.png",
      "/images/5-projeler/konyap_apartmani/6.1_kitchen.png",
      "/images/5-projeler/konyap_apartmani/7_room.png",
      "/images/5-projeler/konyap_apartmani/7.1_room.png",
      "/images/5-projeler/konyap_apartmani/8_lavobo.png",
      "/images/5-projeler/konyap_apartmani/9_hol2.png",
      "/images/5-projeler/konyap_apartmani/10_childroom.png",
      "/images/5-projeler/konyap_apartmani/10.1_childroom.png",
      "/images/5-projeler/konyap_apartmani/10.2_childroom.png",
      "/images/5-projeler/konyap_apartmani/10.3_childroom.png",
      "/images/5-projeler/konyap_apartmani/11_bedroom_1.png",
      "/images/5-projeler/konyap_apartmani/11.1_bedroom_1.png",
    ],
    features: [
      "Panoramik manzara",
      "Kapalı otopark",
      "Bireysel ısıtma sistemi",
      "Yerden ısıtma",
      "Çevreci Mimarlık",
      "Yüksek kaliteli malzeme kullanımı",
      "Peyzajlı Bahçe Alanı",
      "Kameralı güvenlik sistemi",
      "Asansör ve Erişilebilirlik",
    ],
    materialHighlights: [
      // Buraya bu projeye ait marka & malzeme özelliklerini ekle
    ],
    technicalDetails: {
      constructionArea: "3.500 m²",
      greenArea: "",
      blocks: "1 Blok",
      floors: "3 Kat",
      delivery: "Teslim Edildi - Eylül 2024",
    },
    nearby: [
      "Mevlana Müzesi - 0.8 km",
      "Enntepe Alışveriş Merkezi - 1.9 km",
      "Kızılay Hastahanesi - 2.2 km",
      "Şehir Merkezi - 2.3 km",
    ],
  },

  // ─────────────────────────────────────────────────────────────────────────
  // YENİ PROJE ŞABLONU — aşağıdaki yorumu kopyala, /* ve */ sil, doldur
  // ─────────────────────────────────────────────────────────────────────────
  /*
  {
    // ── Temel bilgiler ──────────────────────────────────────────────────────
    id: 6,                              // ← bir önceki id'den +1 yap
    slug: "proje-adi-konya",            // ← URL'de görünecek kısım (Türkçe karakter YOK, boşluk yerine - )
                                        //   Örnek: "sakli-bahce-konya" | "villa-selver-konya"
    seoTitle: "Proje Adı Konya | Konyap Mühendislik",
                                        // ← Google'da başlık olarak görünür
    seoDescription: "Kısa, anahtar kelime içeren açıklama. Google arama sonuçlarında görünür.",
                                        // ← Google'da açıklama satırı (max ~155 karakter)

    // ── Kart & liste bilgileri ──────────────────────────────────────────────
    title: "Proje Adı",
    status: "completed",                // "completed" | "ongoing" | "planning"
    statusLabel: "Tamamlandı",          // "Tamamlandı" | "Devam Ediyor" | "Planlama"
    location: "Meram",                  // Meram | Selçuklu | Karatay
    year: "2025",
    units: "8 Villa",                   // Örnek: "60 Konut" | "1 Adet 4+1 Villa"
    area: "5.000 m²",
    type: "Villa",                      // "Villa" | "Apartman" | "Rezidans" | "Ticari" | "Kooperatif"
    address: "Mahalle Adı, İlçe/Konya",
    coordinates: [37.85, 32.47],        // Google Maps → sağ tık → koordinatları kopyala

    // ── Açıklamalar ────────────────────────────────────────────────────────
    shortDescription: "Proje kartında görünecek 1-2 cümlelik kısa açıklama.",
    description: "Proje detay sayfasında görünecek uzun açıklama. İstediğin kadar uzun yazabilirsin.",

    // ── Görseller ──────────────────────────────────────────────────────────
    coverImage: "/images/5-projeler/proje-adi/kapak.png",

    // Kapak video (isteğe bağlı — biri yeterli, ikisi birden olmasın):
    // MP4 için:
    // coverVideo: "/images/5-projeler/proje-adi/tanitim.mp4",
    // YouTube için (VIDEO_ID'yi iki yere de yaz):
    // coverVideo: "https://www.youtube.com/embed/VIDEO_ID?autoplay=1&mute=1&loop=1&controls=0&rel=0&modestbranding=1&playlist=VIDEO_ID",

    // ── Galeri ─────────────────────────────────────────────────────────────
    gallery: [
      // YouTube video:
      // { type: "youtube", src: "https://www.youtube.com/embed/VIDEO_ID", poster: "/images/5-projeler/proje-adi/kapak.png", thumb: "/images/5-projeler/proje-adi/kapak.png" },
      // MP4 video:
      // { type: "video", src: "/images/5-projeler/proje-adi/video.mp4", poster: "/images/5-projeler/proje-adi/kapak.png", thumb: "/images/5-projeler/proje-adi/kapak.png" },
      // Görsel:
      "/images/5-projeler/proje-adi/kapak.png",
      "/images/5-projeler/proje-adi/1.png",
      "/images/5-projeler/proje-adi/2.png",
    ],

    // ── Özellikler (ikonlu liste) ───────────────────────────────────────────
    features: [
      "Özel Bahçe Alanı",
      "7/24 Site Güvenliği",
      "Kapalı Otopark",
      "Bireysel Isıtma",
      "Panoramik Manzara",
      "Çocuk Oyun Alanı",
    ],

    // ── Malzeme & Marka (kaydırılabilir kart) ──────────────────────────────
    materialHighlights: [
      { title: "Bosch Ev Aletleri", description: "Enerji verimli ankastre beyaz eşyalar." },
      { title: "Vitra", description: "Banyo ve ıslak hacimlerde premium seramik ve armatür." },
      { title: "Egepen Pencere", description: "Isı ve ses yalıtımlı PVC pencere sistemleri." },
    ],

    // ── Teknik bilgiler ────────────────────────────────────────────────────
    technicalDetails: {
      constructionArea: "5.000 m²",
      greenArea: "1.500 m²",
      blocks: "4 Villa",           // Boş bırakırsan ("") satır görünmez
      shopCount: "",               // Ticari alan varsa: "5 Ticari Alan"
      floors: "2 Kat",
      delivery: "Teslim Edildi",   // Devam ediyorsa: "Yapım Aşamasında - 2027"
    },

    // ── Yakın çevre ────────────────────────────────────────────────────────
    nearby: [
      "Meram Tıp Hastanesi - 2 km",
      "Konya Şehir Merkezi - 6 km",
    ],

    // ── Kat planları (isteğe bağlı) ────────────────────────────────────────
    // floorPlans: [
    //   {
    //     typeTitle: "3+1 Villa Tipi",
    //     plans: [
    //       { image: "/images/5-projeler/proje-adi/kat1.png", label: "Zemin Kat\n• Salon 30m²\n• Bahçe 20m²" },
    //       { image: "/images/5-projeler/proje-adi/kat2.png", label: "1. Kat\n• Yatak Odası 15m²" },
    //     ],
    //   },
    // ],
  },
  */
];

export const getFeaturedProjects = () => {
  return projectsData.slice(0, 3);
};
